import React, { useMemo } from "react";
import ScreenCard from "../ScreenCard";
import ListItem, { ListItemProps } from "../../ui_atoms/ListItem";
import { useI18n } from "../../hooks/i18n-hooks";
import { SHORT_DATE_IN_LIST_FORMAT_OPTIONS, useDateFormatter } from "../../hooks/date";
import { useQuery } from "@apollo/client";
import { GET_CLIENT_USERS } from "../../graphql/client";
import { useCurrentProfile } from "../../hooks/use-current-profile";
import { ClientProfile } from "../../__generated__/graphql";
import Loading from "../../components/Loading";

const ClientColleaguesScreen = () => {
    const currentProfile = useCurrentProfile<ClientProfile>();
    const { data: { getClientUsers: clientUsers = [] } = {} } = useQuery(GET_CLIENT_USERS, {
        variables: {
            clientId: currentProfile?.client?.id || "",
        },
    });
    const i18n = useI18n();
    const formatDate = useDateFormatter();

    const data = useMemo<ListItemProps[]>(
        () =>
            clientUsers.map((clientUser) => ({
                title: `${clientUser.firstName} ${clientUser.lastName}`,
                useBigAvatarOrIcon: true,
                tags: [
                    i18n.t("screens.user.my_colleagues.joined_at", {
                        joinedAt: formatDate(
                            clientUser.joinedAt,
                            SHORT_DATE_IN_LIST_FORMAT_OPTIONS,
                        ),
                    }),
                ],
                avatarPath: clientUser.avatarUrl,
            })),
        [clientUsers, formatDate, i18n],
    );

    return (
        <ScreenCard>
            {data ? data.map((d) => <ListItem key={d.title} {...d} />) : <Loading />}
        </ScreenCard>
    );
};

export default ClientColleaguesScreen;
